// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2PlzG","errorLogs":"EditorFooter_errorLogs__2tN1z"};